import { Button } from 'antd';
import { useEffect, useState } from 'react';
import visa from 'assets/images/visa.png';
import mastercard from 'assets/images/mastercard.png';
import { Address } from 'modules/profile/models/Address';

interface InputProps {
	address: Address;
	no: number;
}

function ProfileBillingAddressItemComponent({ address, no }: InputProps) {
	return (
		<div className="d-flex justify-content-between align-items-end flex-wrap gap-2 p-3">
			<div>
				<h6 className="d-flex align-items-center gap-2" style={{ color: '#3F4254' }}>
					Address {no}
					{address.isPrimary && (
						<span className="status active" style={{ fontSize: 12 }}>
							Primary
						</span>
					)}
				</h6>
				<p style={{ fontWeight: 500, margin: 0, color: '#aaa' }}>{address.location}</p>
				<p style={{ fontWeight: 500, margin: 0, color: '#aaa' }}>{address.state}</p>
				<p style={{ fontWeight: 500, margin: 0, color: '#aaa' }}>{address.country}</p>
			</div>
			<div className="d-flex justify-content-end gap-2 flex-grow-1">
				<Button className="danger">Delete</Button>
				<Button className="discard">Edit</Button>
			</div>
		</div>
	);
}

export default ProfileBillingAddressItemComponent;
